import React from 'react'
import { withTranslation } from 'react-i18next'

import Modal from '../Modal'

import Slide from './Slide'

import './AddNewSlide.scss'

const AddNewSlide = ({ options, selectCallback, open, onClose, t }) => (
    <Modal
        settings={{ overlay_close: false }}
        data={{ open }}
        events={{ onCloseModal: onClose }}
        classes={{ modal: 'add-new-slide' }}
    >
        <div className="add-new-slide__head">{t('_components._add_new_slide.title')}</div>
        <div className="add-new-slide__main">
            <h1>{t('_components._add_new_slide.description')}</h1>
            <div className="add-new-slide__grid">
                {options.map(option => {
                    return (
                        <Slide
                            key={option.name}
                            name={option.name}
                            content={<img src={option.icon.main} />}
                            contentHover={<img src={option.icon.hover} />}
                            onClick={() => {
                                selectCallback(option)
                                onClose()
                            }}
                        />
                    )
                })}
            </div>
        </div>
    </Modal>
)

export default withTranslation('translations')(AddNewSlide)
